import React, {Fragment} from 'react';
import {Stack, Typography} from '@mui/material';

import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {AlertActions, AlertModal} from 'presentation/components';
import {useDuplicityAuthStore} from 'presentation/modules/booking/shared/store/useDuplicityAuthStore';
import {useHealthDuplicityDialog} from './hooks/useHealthDuplicityDialog';
import {HealthDuplicityDialogProps} from './types';
import {HealthDuplicityBookedCard} from '../HealthDuplicityBookedCard';

export function HealthDuplicityDialog({
	open,
	setOpen,
	scheduledBooking,
	isScheduleScript,
	swapSpecialtyCallback,
	isAuthorized: isAuthorizedProp,
}: HealthDuplicityDialogProps) {
	const isAuthorizedFromStore = useDuplicityAuthStore(state => state.duplicityAuth);
	const isAuthorized = isAuthorizedProp !== undefined ? isAuthorizedProp : isAuthorizedFromStore;
	const {
		handleSwapSpecialty,
		colors,
		isMobile,
		disabledSwapSpecialtyButton,
		handleClose,
		alertModalPaperProps,
		contentTitle,
		contentDescription,
		getSecondaryText,
		shouldProceedWithTelehealth,
		actionSelected,
	} = useHealthDuplicityDialog({
		scheduledBooking,
		setOpen,
		isScheduleScript,
		swapSpecialtyCallback,
		isAuthorized,
	});

	const isPrimaryAction = actionSelected === 'primary';
	const isSecondaryAction = actionSelected === 'secondary';

	return (
		<AlertModal
			data-tag-id={FinishWithoutCompleteFlowEnum.POSSUI_CONSULTA_EXISTENTE_ESPECIALIDADE}
			showIcon={false}
			description={isMobile ? undefined : contentDescription}
			headerTitle={contentTitle}
			onClose={isScheduleScript ? undefined : handleClose}
			disableClose={isScheduleScript}
			open={open}
			variant="warning"
			fullScreen={isMobile}
			slotProps={{
				paper: {
					style: alertModalPaperProps,
				},
			}}
			footerProps={{
				sx: {
					p: 0,
				},
			}}
			customContentStyles={{
				sx: {
					p: isMobile ? 0 : 3,
				},
			}}
			subDescription={
				<Fragment>
					{isMobile ? (
						<Stack sx={{bgcolor: colors.brand.primary.blue}} p={3}>
							<Typography variant="h6" color={colors.brand.primary.white}>
								{contentDescription}
							</Typography>
						</Stack>
					) : null}
					<Stack px={isMobile ? 3 : 0} width={'100%'}>
						<HealthDuplicityBookedCard
							scheduledBooking={scheduledBooking}
							isScheduleScript={!!isScheduleScript}
						/>
					</Stack>
				</Fragment>
			}
			footerContent={
				<AlertActions
					primaryAction={async () => await handleSwapSpecialty({isRebooking: true})}
					secondaryAction={async () =>
						shouldProceedWithTelehealth
							? await handleSwapSpecialty({isRebooking: false})
							: handleClose()
					}
					secondaryText={getSecondaryText()}
					primaryText={contentTitle}
					flexDirection={'column-reverse'}
					isDisabled={disabledSwapSpecialtyButton && isPrimaryAction}
					isLoading={disabledSwapSpecialtyButton && isPrimaryAction}
					isDisabledSecondary={disabledSwapSpecialtyButton && isSecondaryAction}
					isLoadingSecondary={disabledSwapSpecialtyButton && isSecondaryAction}
					secondaryBtnVariant="outlined"
					customStackProps={{bgcolor: colors.brand.primary.white, p: '8px 16px'}}
				/>
			}
		/>
	);
}
